/**
 * ZAC's version as WoW shows a patch (docs/versioning.md): `1.0.0 (1662)`, with where it runs and the commit built.
 */
export const APP_VERSION = {
  version: __APP_VERSION__,
  build: __APP_BUILD__,
  commit: __APP_COMMIT__,
  channel: __APP_CHANNEL__,
  builtAt: __APP_BUILT_AT__,
};

/** "ZAC 1.0.0 (1662) · Beta · bed22d1". */
export function versionLine(): string {
  return `ZAC ${APP_VERSION.version} (${APP_VERSION.build}) · ${APP_VERSION.channel} · ${APP_VERSION.commit}`;
}

/** The tooltip: when it was built. */
export function versionTitle(): string {
  return `Version ${APP_VERSION.version}, build ${APP_VERSION.build} (${APP_VERSION.channel}), commit ${APP_VERSION.commit}, built ${new Date(APP_VERSION.builtAt).toUTCString()}`;
}
